import styled, { css } from 'styled-components';

export const Input = styled.input<{
    customBorderRadius?: number;
    isDisabled?: boolean;
    isError?: boolean;
    isIcon?: boolean;
    inputType?: string;
}>(
    ({
        customBorderRadius,
        isDisabled,
        isError,
        isIcon,
        inputType,
        theme: { colors, fontFamily, fontSizes, fontWeight, borderRadius },
    }) => css`
        background: ${colors.app_bg};
        border-radius: ${customBorderRadius
            ? customBorderRadius
            : borderRadius.textarea}px;
        border: 1px solid ${isError ? colors.error : colors.inputBorder};
        color: ${colors.text};
        font-family: ${fontFamily.secondary};
        font-size: ${fontSizes.f16};
        font-weight: ${fontWeight.regular};
        opacity: ${isDisabled ? 0.5 : 1};
        outline: none;
        padding: ${inputType === 'password'
            ? '15px 50px 15px 60px'
            : isIcon
            ? '15px 15px 15px 60px'
            : '15px 18px'};
        width: 100%;

        &::-webkit-input-placeholder,
        &::-ms-input-placeholder {
            color: ${colors.text};
        }

        &:active,
        &:focus {
            border: 1px solid ${isError ? colors.error : colors.inputBorder};
        }

        &[type='number'] {
            -moz-appearance: textfield;
            appearance: textfield;
        }

        &[type='number']::-webkit-inner-spin-button,
        &[type='number']::-webkit-outer-spin-button {
            -webkit-appearance: none;
            margin: 0;
        }
    `,
);

export const InputLabel = styled.span(
    ({ theme: { fontFamily, fontSizes, colors } }) =>
        css`
            color: ${colors.text}99;
            font-family: ${fontFamily.secondary};
            font-size: ${fontSizes.f12};
            line-height: 30px;
            margin-left: 18px;
        `,
);

export const InputWrapper = styled.div<{
    marginBottom?: number;
    isError?: boolean;
}>(
    ({ marginBottom, isError }) => css`
        align-items: flex-start;
        display: flex;
        flex-direction: column;
        position: relative;
        width: 100%;
        margin-bottom: ${isError
            ? '6px'
            : marginBottom
            ? marginBottom + 'px'
            : '0'};
    `,
);

export const IconWrapper = styled.div`
    left: 23px;
    position: absolute;
    top: 13px;
`;

export const EyeIconWrapper = styled.div`
    position: absolute;
    right: 20px;
    top: 13px;
`;
